export default __webpack_public_path__ + "static/media/session.c8535a27.svg";